import React, { BaseSyntheticEvent, FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";
import { useReactiveVar } from "@apollo/client";
import { isPaymentFailedShow, isTrialEndedShow } from "../../../graphql/state";
import trialEnded from "./trial-ended.webp";

type Props = {
  show: boolean;
  onCancel?: () => void;
};

const TrialEndedModal: FC<Props> = ({ show, onCancel }) => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const navigate = useNavigate();
  const isPaymentFailed = useReactiveVar(isPaymentFailedShow);

  const closeByBackground = (e: BaseSyntheticEvent) => {
    e.stopPropagation();
    if (e.target.id === "trialEndedModal") onCancel?.();
  };

  const goToPayment = () => {
    navigate(`${lng}/payment`);
    isTrialEndedShow(false);
  };

  const goToProjects = () => {
    navigate(`${lng}/projects`);
    isTrialEndedShow(false);
  };

  return (
    <div
      id="trialEndedModal"
      className={`modal ${show ? "show d-flex" : ""} align-items-center justify-content-center`}
      style={{ background: "rgb(0, 0, 0, 0.6)", zIndex: 2100 }}
      onClick={(e) => closeByBackground(e)}
    >
      <div className="col-11" style={{ maxWidth: "500px" }}>
        <div className="modal-content text-break d-flex flex-column align-items-center rounded-4">
          <div className="col-12 modal-header border-0 justify-content-end">
            <button
              className="btn-close"
              aria-label="Close"
              onClick={onCancel}
              style={{ height: "16px", width: "16px", opacity: "1" }}
            />
          </div>
          <div className="border-0 text-center d-flex flex-column align-items-center px-4 pb-2">
            <img
              src={trialEnded}
              alt="trial ended"
              className="mb-3"
              width={193}
            />
            <h4 className="fw-bold fs-4 fs-md-3 text-dark mb-2">
              {isPaymentFailed
                ? t("payment.paymentFailedTitle")
                : t("modal.trialEndedTitle")}
            </h4>
            <p className="text-dark fs-7 fs-md-6 mb-0 px-md-4">
              {isPaymentFailed
                ? t("payment.paymentFailedDescription")
                : t("modal.trialEndedDescription")}
            </p>
          </div>
          <div className="modal-footer d-flex flex-column align-items-center pb-4 border-0 w-100 text-center">
            <button
              type="button"
              className="btn btn-primary text-white fw-bold fs-6 w-100 rounded-3 py-2 py-md-3 mb-3 mb-md-4"
              onClick={goToPayment}
            >
              {isPaymentFailed
                ? t("payment.paymentFailedCta")
                : t("modal.trialEndedCta")}
            </button>
            <p
              className="d-inline text-decoration-underline m-0 cursor-pointer fs-7 fs-md-6"
              onClick={goToProjects}
            >
              {t("modal.trialEndedGoToProjects")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialEndedModal;
